import React from 'react';
import { Badge, BadgeType } from '@enter/core';
import type { StatementTabId } from '../statement-details.types';
import * as S from '../statement-details.styles';

export type StatementTabItem = {
    id: StatementTabId;
    label: string;
    count?: number;
};

export type StatementTabsBarProps = {
    tabs: StatementTabItem[];
    activeTab: StatementTabId;
    onTabChange: (tab: StatementTabId) => void;
};

export const StatementTabsBar: React.FC<StatementTabsBarProps> = ({ tabs, activeTab, onTabChange }) => (
    <S.StatementTabs role="tablist">
        {tabs.map(tab => {
            const active = activeTab === tab.id;
            return (
                <S.StatementTab
                    key={tab.id}
                    type="button"
                    variant="unstyled"
                    $active={active}
                    onClick={() => onTabChange(tab.id)}>
                    {tab.label}
                    {tab.count != null && (
                        <S.TabBadgeWrap>
                            <Badge type={active ? BadgeType.BLUE_LIGHT : undefined} size="small">
                                {tab.count}
                            </Badge>
                        </S.TabBadgeWrap>
                    )}
                </S.StatementTab>
            );
        })}
    </S.StatementTabs>
);
